import { connect } from 'react-redux';

import GroupComponent from './GroupComponent';

import {
  teamFeedActions,
  teamFeedOperations,
  teamFeedSelectors,
} from '../../duck';

const mapStateToProps = (state) => {
  const {
    appReducer,
    teamFeedReducer,
    locationReducer,
  } = state;

  return {
    comments: teamFeedSelectors.getOrderedComments(teamFeedReducer),
    activePost: teamFeedSelectors.getActivePost(teamFeedReducer),
    active: teamFeedReducer.active,
    locationSettings: appReducer.location.settings,
    locationId: locationReducer.location_code,
    locations: locationReducer.locations,
    activeChannel: teamFeedSelectors.getActiveChannel(state),
    activeChannelRefreshToken: teamFeedSelectors.getActiveChannelRefreshToken(state),
    allUsers: appReducer.allUsers.users,
    managers: appReducer.managers.users,
    associates: appReducer.associates.users,
    onlineUsers: appReducer.onlineUsers.users,
  };
};

const mapDispatchToProps = (dispatch) => {
  const fetchPostLikeList = (post_id) => {
    dispatch(teamFeedOperations.getPostLikeList(post_id));
  };

  const fetchPostReaderList = (post_id) => {
    dispatch(teamFeedOperations.getPostReaderList(post_id));
  };

  const resetActiveSidePane = () => {
    dispatch(teamFeedActions.updateActiveSidePane(''));
  };

  const setActiveSidePane = (pane) => {
    dispatch(teamFeedActions.updateActiveSidePane(pane));
  };

  const addRemoveChannelUsers = (selectedUsers, channelId, mode, subscriptionId) => {
    if (mode === 'add') {
      const promises = selectedUsers.map(user =>
        dispatch(teamFeedOperations.addUserToChannel(user, channelId, subscriptionId))
      );
      console.log('Promises:', promises);
      Promise.all(promises)
        .then(() => {
          console.log('All users added to the channel');
          // Optionally dispatch something to refresh UI
          dispatch(teamFeedActions.updateActiveChannelRefresh());
        })
        .catch((error) => {
          console.error('Error adding users:', error);
        });
    } else if (mode === 'remove') {
      const promises = selectedUsers.map(user =>
        dispatch(teamFeedOperations.removeUserFromChannel(user, channelId, subscriptionId))
      );

      Promise.all(promises)
        .then(() => {
          console.log('All users removed from the channel');
          // Optionally dispatch something to refresh UI
          dispatch(teamFeedActions.updateActiveChannelRefresh());
        })
        .catch((error) => {
          console.error('Error removing users:', error);
        });
    }
  }

  const updateChannelInfo = (channelId, name, description) => {
    dispatch(teamFeedOperations.updateChannelInfo(channelId, name, description));
  }

  const updateChannelMuteStatus = (channelId, subscriptionId, muteStatus) => {
    dispatch(teamFeedOperations.updateChannelMuteStatus(channelId, subscriptionId, muteStatus));
  }

  const handleRemoveUserFromGroup = (channelId, users) => {
    dispatch(teamFeedOperations.leaveGroup(channelId, users));
  };

  const handleDeleteGroup = (channelId, users) => {
    dispatch(teamFeedOperations.deleteGroup(channelId, users));
  };


  return {
    fetchPostLikeList,
    fetchPostReaderList,
    resetActiveSidePane,
    setActiveSidePane,
    updateChannelInfo,
    handleRemoveUserFromGroup,
    updateChannelMuteStatus,
    handleDeleteGroup,
    addRemoveChannelUsers,
  };
};

const GroupContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupComponent);


export default GroupContainer;
